import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { loadExchangesAllSuccess } from 'src/app/redux/actions/exchange.action';
import { resetLastUpdate, setLastUpdate, setLocation } from 'src/app/redux/actions/options.action';
import { localStorageNames } from 'src/app/shared/const/localStorageNames';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { DateChecker } from '@shared-logic/utils';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { MaestrosService } from 'src/app/shared/services/mestros.service';
import { DataRefreshService } from 'src/app/shared/services/data-refresh.service';
import { SessionChecker } from 'src/app/shared/session.checker';
import { TablesIBMClass } from 'src/app/shared/tables-ibm';
import { selectAllExchanges } from 'src/app/redux/selectors/exchanges.selectors';

@Component({
  selector: 'app-exchange-list',
  templateUrl: './exchange-list.component.html',
  styleUrls: ['./../../shared/styles/body.scss']
})
export class ExchangeListComponent extends TablesIBMClass implements OnInit, OnDestroy {

  constructor(private store: Store<appState>, private checker: SessionChecker,
    maestroSvc: MaestrosService, private dataRefreshService: DataRefreshService) {
    super(maestroSvc);
    this.loadExchanges();

    this.checker.rememberAndActualizateUser(this.store);

    this.store.dispatch(setLocation({ location: NAVEGATION.ORDER_EXCHANGE }));
  }

  ngOnInit(): void {
    this.checkTables();
  }

  ngOnDestroy(): void {
    this.store.dispatch(resetLastUpdate())
  }

  loadExchanges() {
    this.dataRefreshService.refreshExchanges();
  }
}